var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = "/monitoring";
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"8f672ac0b3c5518fc3a205194a6d01635c6ef372"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/storefront/8f672ac0b3c5518fc3a205194a6d01635c6ef372";

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';
import getConfig from 'next/config';

const envVars = getConfig().publicRuntimeConfig;

Sentry.init({
  dsn: envVars.SENTRY_DSN || '',
  release: envVars.SENTRY_RELEASE || '',
  tracesSampleRate: 0.1,
  debug: false,
  integrations: [
    Sentry.thirdPartyErrorFilterIntegration({
      filterKeys: ['storefront'],
      behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
    }),
  ],
});
